import request from './chatRequest'
import store from '@/store'

/**
 * 房间列表
 * @param data
 * @returns {AxiosPromise}
 */
const bind = (data) => {
  return request({
    url: 'bind',
    method: 'post',
    data: data
  })
}

/**
 * 房间列表
 * @returns {AxiosPromise}
 */
const roomList = () => {
  return request({
    url: 'room/list',
    method: 'get',
    params: {client: 'front'}
  })
}

/**
 * 进入房间
 * @param id
 * @returns {AxiosPromise}
 */
const enterRoom = (id) => {
  return request({
    url: 'room/enter',
    method: 'post',
    data: {client: 'front', room_id: id, client_id: store.state.client_id}
  })
}

/**
 * 退出房间
 * @param id
 * @returns {AxiosPromise}
 */
const killRoom = (id) => {
  return request({
    url: 'room/kill',
    method: 'post',
    data: {client: 'front', room_id: id, client_id: store.state.client_id}
  })
}

/**
 * 获取历史消息
 * @param id
 * @returns {AxiosPromise}
 */
const getOldMessage = (id, roomId) => {
  return request({
    url: `message/history?id=${id}&room_id=${roomId}&client=front`,
    method: 'get'
  })
}

/**
 * 发送消息
 * @param data 数据
 * @param progressFun 文件上传进度
 * @returns {*}
 */
const sendMsg = (data, progressFun) => {
  return request({
    url: `message/send`,
    method: 'post',
    data,
    onUploadProgress: progressFun
  })
}

/**
 * 创建房间 发起私聊
 * @param data 数据
 * @returns {*}
 */
const createRoom = (data) => {
  return request({
    url: `room/create`,
    method: 'post',
    data: {client: 'front', ...data}
  })
}

/**
 * 退出聊天室
 * @param id 数据
 * @returns {*}
 */
const quit = (id) => {
  return request({
    url: `room/quit`,
    method: 'post',
    data: {client: 'front', room_id: id}
  })
}

/**
 * 关闭聊天室
 * @param id 数据
 * @returns {*}
 */
const close = (id) => {
  return request({
    url: `room/close`,
    method: 'post',
    data: {client: 'front', room_id: id}
  })
}

/**
 * 置顶聊天室
 * @param data 数据
 * @returns {*}
 */
const top = (data) => {
  return request({
    url: `room/top`,
    method: 'post',
    data: {client: 'front', ...data}
  })
}

/**
 * 消息免打扰
 * @param data 数据
 * @returns {*}
 */
const disturb = (data) => {
  return request({
    url: `room/disturb`,
    method: 'post',
    data: {client: 'front', ...data}
  })
}

/**
 * 搜索全部
 * @param match 数据
 * @returns {*}
 */
const searchAll = (match) => {
  return request({
    url: `search/all`,
    method: 'get',
    params: {client: 'front', match}
  })
}

/**
 * 撤回消息
 * @param data 数据
 * @returns {*}
 */
const revoke = (data) => {
  return request({
    url: `message/revoke`,
    method: 'post',
    data: {client: 'front', ...data}
  })
}

/**
 * 确认踢出群聊
 * @param data 数据
 * @returns {*}
 */
const confirmKick = (data) => {
  return request({
    url: `room/confirmkick`,
    method: 'post',
    data: {client: 'front', ...data}
  })
}

export default {
  bind,
  roomList,
  enterRoom,
  killRoom,
  getOldMessage,
  sendMsg,
  createRoom,
  quit,
  close,
  top,
  disturb,
  searchAll,
  revoke,
  confirmKick
}
